import { Injectable } from '@angular/core';
import { TokenStorageService } from 'src/app/shared/token-storage';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private user: any = null;

  tvMode: boolean = false;

  showNavigationMain: boolean = false;
  showFilter: boolean = false;
  
  chatPage: string = 'courses'; //board, list, courses === panel

  showPopupAddColumn: boolean = false;
  userBoards: any[] = [];
  userBoardColumns: any[] = [];
  showDropdownBoards: boolean = false;
  activeBoardName: string = '';
  activeBoardId: number = 0;

  constructor(private tokenStorage: TokenStorageService) {
  }

  getUser() {
    return this.tokenStorage.getUser();
  }
  setUser(data) {
    this.user = data
  }
  
  formatted(price: any, digits: number = 2, currency: string = 'EUR') {
    price = `${price}`;
    let format: any = {
      style: 'decimal',
      minimumFractionDigits: digits,
    }
    if (currency) {
      format = {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
      }
    }
    let formattedPrice = new Intl.NumberFormat('de-DE', format).format(parseFloat(`${price.replace(',','.')}`));
    return formattedPrice;
  }
}
